/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedDataDcUserDto } from '../../models/paginated-data-dc-user-dto';

export interface GetUsers$Params {
  searchStr?: string;
  pageNumber?: number;
  count?: number;

/**
 * Sort order by username
 */
  dir?: 'ASC' | 'DESC';
  withInactive?: boolean;
}

export function getUsers(http: HttpClient, rootUrl: string, params?: GetUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDataDcUserDto>> {
  const rb = new RequestBuilder(rootUrl, getUsers.PATH, 'get');
  if (params) {
    rb.query('searchStr', params.searchStr, {});
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('count', params.count, {});
    rb.query('dir', params.dir, {});
    rb.query('withInactive', params.withInactive, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedDataDcUserDto>;
    })
  );
}

getUsers.PATH = '/api/users';
